import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('home-app-bar'),_c('home-view'),_c('home-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }